import api from ".";

export const createSubAccount = ({ businessUuid, ...data }) => api.post(`/subaccounts`, data, { params: { businessUuid } });

export const editSubAccount = ({ uuid, ...data }) => api.put(`/subaccounts/${uuid}`, data);

export const deleteSubAccount = ({ uuid, ...data }) => api.delete(`/subaccounts/${uuid}`);

export const getSubAccounts = (params) => api.get(`/subaccounts/business`, { params });
